import { contains } from 'ramda';

const genericLabels = ['Response', 'Answer', 'Vendor Answer', 'Attachment'];

export default (label: string) => contains(label, genericLabels);
